var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5508 2.75C23.5508 1.5125 22.5158 0.5 21.2508 0.5H2.85078C1.58578 0.5 0.550781 1.5125 0.550781 2.75V16.25C0.550781 17.4875 1.58578 18.5 2.85078 18.5H21.2508C22.5158 18.5 23.5508 17.4875 23.5508 16.25V2.75ZM21.2508 2.75L12.0508 8.375L2.85078 2.75H21.2508ZM21.2508 16.25H2.85078V5L12.0508 10.625L21.2508 5V16.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIconWhite);
export default __webpack_public_path__ + "static/media/mail_icon_white.4ac067f6b7587d13b656f20a807db6e6.svg";
export { ForwardRef as ReactComponent };